"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.taskTypeOptions = exports.taskCodeOptions = exports.rewardTypeOptions = void 0;
var taskCodeOptions = exports.taskCodeOptions = [{
  label: '每日任务',
  value: 'daily_task',
  tag: 'green'
}, {
  label: '惊喜任务',
  value: 'surprise_task',
  tag: 'orange'
}, {
  label: '看视频得金币',
  value: 'video_task',
  tag: 'red'
}, {
  label: '佣金任务',
  value: 'commission_task',
  tag: 'blue'
}, {
  label: '逛商城商品',
  value: 'browse_product_task',
  tag: 'cyan'
}];
var taskTypeOptions = exports.taskTypeOptions = [{
  label: '定时抽奖',
  value: '1',
  disabled: false
}, {
  label: '十宫格抽奖',
  value: '2',
  disabled: false
}, {
  label: '激励视频',
  value: '3',
  disabled: false
}, {
  label: '加客服',
  value: '4',
  disabled: false
}, {
  label: '公众号单篇阅读',
  value: '5',
  disabled: false
}, {
  label: '逛商城商品',
  value: '6',
  disabled: false
}, {
  label: '跳转小程序',
  value: '7',
  disabled: false
}];
var rewardTypeOptions = exports.rewardTypeOptions = [{
  label: '积分',
  value: 1,
  disabled: false
}, {
  label: '红包',
  value: 2,
  disabled: false
}, {
  label: '佣金',
  value: 3,
  disabled: false
}];